import React from "react"

import { Link } from "gatsby"

import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./WinterCollections.scss"

const WinterCollections = ({ section }) => {
  return (
    <section className="winter-collections">
      <Fade>
        <div className="winter-collections__description">
          <div className="winter-collections__description__text">
            <p className="winter-collections__description__text__top">
              {section.title || "Lorem Ipsum"}
            </p>
            <p className="winter-collections__description__text__title">
              {section.subtitle || "Lorem Ipsum Subtitle"}
            </p>
            <p className="winter-collections__description__text__body">
              {section.description ||
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
            </p>
            <button className="winter-collections__description__text__btn">
              <Link to={`/${section.buttonLink}`}>
                {section.buttonText || "Lorem Button"}
              </Link>
            </button>
          </div>
          <img
            src={
              section.image1?.url ||
              "https://images.unsplash.com/photo-1622497170185-5d668f816a56?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTd8fG1lbiUyMGZhc2hpb258ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60"
            }
            alt={section.image1?.alt}
            loading="lazy"
          />
        </div>
        <div className="winter-collections__image">
          <img
            src={
              section.image2?.url ||
              "https://images.unsplash.com/photo-1617127365659-c47fa864d8bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bWVuJTIwZmFzaGlvbnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
            }
            alt={section.image2?.alt}
            loading="lazy"
          />
        </div>
      </Fade>
    </section>
  )
}

WinterCollections.propTypes = {
  section: PropTypes.object.isRequired,
}

export default WinterCollections
